module.exports = __webpack_public_path__ + "static/media/rome.2656bfbe.jpeg";